import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { CheckIn } from 'src/model/checkIn.model';

@Injectable({
  providedIn: 'root'
})
export class CheckInAdapter {
  adapt(item: any): CheckIn {
    return new CheckIn(
      item.id,
      new Date(item.date),
      new Date(item.dateCreated),
      item.companyId,
      item.remark,
      item.username,
      item.role,
      item.roleId
    )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  protected api = inject(RestApiService);
  protected checkInAdapter = inject(CheckInAdapter);
  protected constructApi = inject(ConstructAPI);

  // #region 'CheckIns'
  getCompaniesLatestCheckIns(compId?: number, aDate?: string, roleId?: number) {
    return new Promise<CheckIn[]>((resolve, reject) => {
      this.api.get<CheckIn[]>(this.constructApi.getCompaniesLatestCheckIns(compId, aDate, roleId)).pipe(
        map(data => data.map(d => this.checkInAdapter.adapt(d)))
      ).subscribe({
        next: response => resolve(response),
        error: err => {
          this.api.handleError(err);
          console.error(err);
          reject(err);
        }
      })
    })
  }
  // #endregion
}